<!-- 遅延ロード中表示 -->
<div *ngIf="isShowingRouteLoadIndicator" id="lazy-loading">
  <div class="body">
    <img src="../assets/images/logo_signin_smile9.png">
    <div>データ取得中です。しばらくお待ちください...</div>
  </div>
</div>

<!-- ↓ナビバー表示部分 -->
<div *ngIf="(authServ.loggedIn | async) && !authServ.mode.firstPassSettingMode && !authServ.isPrinting" [class.d-none]="authServ.isWaitAuthenticating ||
                      authServ.smile9Role === SMILE9_ROLES.ITADAKIMASU ||
                      authServ.smile9Role === SMILE9_ROLES.MENU_DISPLAY ||
                      isRegisterFavInUrl ||
                      isMaintenanceUrl" class="app-navbar" [class.app-navbar-rsv]="isCurrentPath('individual')">
  <app-navbar></app-navbar>
</div>

<!-- ↓コンテンツ表示部分 -->
<div *ngIf="authServ.isWaitAuthenticating" class="loading-area-lg">
  <app-loading [loadType]="'authenticating'"></app-loading>
</div>
<div [class.d-none]="authServ.isWaitAuthenticating" [class.content-area]="!authServ.isPrinting"
  [class.content-area-rsv]="isCurrentPath('individual')"
  [class.content-area-signin]="getCurrentPathname() === '/signin'"
  [class.content-area-card-signin]="getCurrentPathname() === '/card-signin'"
  [class.content-area-fsc-signin]="getCurrentPathname() === '/fsc-signin'"
  [class.content-area-demo-signin]="getCurrentPathname() === '/demo-signin'"
  [class.content-area-itadakimasu]="getCurrentPathname() === '/scan-card/itadakimasu'"
  [class.content-area-display-menu]="getCurrentPathname() === '/cafemenu-term/display-menu'"
  [class.content-area-search-emp-code]="getCurrentPathname() === '/scan-card/search-emp-code'"
  [class.content-area-no-rsv-scan-card]="getCurrentPathname() === '/scan-card/no-rsv-scan-card'"
  [class.content-area-gochi]="getCurrentPathname() === '/scan-card/scan-cafeteria'"
  [class.content-area-self-regi]="getCurrentPathname() === '/scan-card/self-regi'">
  <router-outlet></router-outlet>
</div>

<!-- ↓Footer表示部分 -->
<footer *ngIf="(authServ.loggedIn | async) &&
                !authServ.mode.firstPassSettingMode &&
                !authServ.isPrinting &&
                !isRegisterFavInUrl" [class.d-none]="authServ.isWaitAuthenticating">
  <!-- PC、タブレットのみ -->
  <section id="only-pc-tablet">
    <div class="nav-footer" [class.d-none]="authServ.smile9Role === SMILE9_ROLES.KITCHEN ||
                                            authServ.smile9Role === SMILE9_ROLES.ITADAKIMASU ||
                                            authServ.smile9Role === SMILE9_ROLES.MENU_DISPLAY">
      <div class="row">
        <section class="col-auto mr-auto d-flex flex-row mb-3">
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS" class="footer-block">
            <p class="footer-title">予約</p>
            <div class="footer-menu">
              <p
                *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_DASHBOARD">
                <a routerLink="/general-affairs/reservation/ga-dashboard">ダッシュボード</a>
              </p>
              <p><a routerLink="/general-affairs/reservation/ga-rsv-result">予約実績リスト</a></p>
              <p><a routerLink="/general-affairs/reservation/ga-rsv-status">予約状況リスト</a></p>
              <p><a routerLink="/general-affairs/reservation/ga-individual-rsv-status">個人予約状況リスト</a></p>
              <p><a routerLink="/general-affairs/reservation/display-rsv-log">予約ログ照会</a></p>
              <p><a routerLink="/general-affairs/reservation/rsv-log">いただきますログ照会</a></p>
              <p><a routerLink="/general-affairs/reservation/ga-input-rsv">予約入力</a></p>
              <p><a routerLink="/general-affairs/reservation/bulk-rsv">予約一括入力</a></p>
              <p><a routerLink="/general-affairs/reservation/ga-edit-rsv">予約編集</a></p>
              <p><a routerLink="/general-affairs/reservation/update-in-bulk">予約一括編集</a></p>
              <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                  routerLink="/general-affairs/reservation/modify-regi-result">セルフレジ実績編集</a></p>
              <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                  routerLink="/general-affairs/reservation/ga-selfregi-rsv-result">セルフレジ実績リスト</a></p>
              <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                  routerLink="/general-affairs/reservation/ga-individual-regi-rsv-status">個人セルフレジ実績リスト</a></p>
            </div>
          </div>
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS" class="footer-block">
            <p class="footer-title">総務</p>
            <div class="footer-menu">
              <p><a routerLink="/general-affairs/general-affairs/automenu">自動メニュー登録</a></p>
              <p><a routerLink="/general-affairs/general-affairs/ga-menu-list">食堂メニューリスト</a></p>
              <p
                *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_RSV">
                <a routerLink="/general-affairs/general-affairs/ga-modify-rsv">予約調整入力</a>
              </p>
              <p
                *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_ATE">
                <a routerLink="/general-affairs/general-affairs/modify-result">実績調整入力</a>
              </p>
              <p
                *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_FAXMAIL_SETTINGS">
                <a routerLink="/general-affairs/general-affairs/faxmail-settings">FAX送信設定</a>
              </p>
              <p><a routerLink="/general-affairs/general-affairs/dl-data">データDL</a></p>
              <p><a routerLink="/general-affairs/general-affairs/dl-data-custom">データDLカスタマイザ</a></p>
              <p><a routerLink="/general-affairs/general-affairs/guest-info">ゲスト情報リスト</a></p>
              <p><a routerLink="/general-affairs/general-affairs/register-felica">Smile9ID登録</a></p>
              <p><a routerLink="/general-affairs/general-affairs/edit-notice">通知編集</a></p>
              <p
                *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE">
                <a routerLink="/general-affairs/general-affairs/ga-nutrition-balance">栄養バランス</a>
              </p>
            </div>
          </div>
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS" class="footer-block">
            <p class="footer-title">管理</p>
            <div class="d-flex flex-row footer-menu">
              <div>
                <p class="footer-subtitle">基本情報</p>
                <p><a routerLink="/general-affairs/master/company">会社リスト</a></p>
                <p><a routerLink="/general-affairs/master/department">部署リスト</a></p>
                <p><a routerLink="/general-affairs/master/employee">社員リスト</a></p>
                <p><a routerLink="/general-affairs/master/import-emp-csv">社員CSV取込</a></p>
                <p><a routerLink="/general-affairs/master/holiday-pattern">休日パターン</a></p>
              </div>
              <div class="ml-5">
                <p class="footer-subtitle">Smile9情報</p>
                <p><a routerLink="/general-affairs/master/cafeteria">食堂リスト</a></p>
                <p><a routerLink="/general-affairs/master/cafe-opening-hours">食堂設定</a></p>
                <p><a routerLink="/general-affairs/master/bill">請求先リスト</a></p>
                <p><a routerLink="/general-affairs/master/cafe-bill">食堂請求先設定</a></p>
                <p
                  *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.DISPLAY_GA_ITADAKIMASU_SETTINGS">
                  <a routerLink="/general-affairs/master/itadakimasu-settings">いただきます端末設定</a>
                </p>
                <p><a routerLink="/general-affairs/master/cafe-business-calendar">食堂営業日カレンダー</a></p>
                <p><a routerLink="/general-affairs/master/disp-price">価格表示設定</a></p>
                <p><a routerLink="/general-affairs/master/sei-kbn">請求区分リスト</a></p>
                <p><a routerLink="/general-affairs/master/menu-type">メニュー種類リスト</a></p>
                <p><a routerLink="/general-affairs/master/menu-tanka">メニュー単価設定</a></p>
                <p><a routerLink="/general-affairs/master/cafe-hojo-group">補助食堂グループリスト</a></p>
                <p><a routerLink="/general-affairs/master/cafe-hojo-settings">補助食堂設定</a></p>
                <p><a routerLink="/general-affairs/master/menu-pattern">メニューパターン設定</a></p>
                <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'"><a
                    routerLink="/general-affairs/master/sub-menu-group">サブメニューグループリスト</a></p>
                <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'"><a
                    routerLink="/general-affairs/master/sub-menu-pattern">サブメニューパターン設定</a></p>
                <p><a routerLink="/general-affairs/master/cafe-available-group">利用食堂グループリスト</a></p>
                <p><a routerLink="/general-affairs/master/cafe-available-settings">利用食堂設定</a></p>
              </div>
            </div>
          </div>

          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC" class="footer-block">
            <p class="footer-title">メニュー</p>
            <div class="footer-menu">
              <p
                *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_DASHBOARD">
                <a routerLink="/fsc/fsc-dashboard">ダッシュボード</a>
              </p>
              <p><a routerLink="/fsc/fsc-rsv-result">予約実績リスト</a></p>
              <p><a routerLink="/fsc/import-menu-csv">食堂メニューCSV取込</a></p>
              <p><a routerLink="/fsc/menu-list">食堂メニューリスト</a></p>
              <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'"><a
                  routerLink="/fsc/sub-menu-list">サブメニューリスト</a></p>
              <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'"><a
                  routerLink="/fsc/sub-menu-settings">サブメニュー設定</a></p>
              <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                  routerLink="/fsc/self-regi-menu-list">セルフレジメニューリスト</a></p>
              <p><a routerLink="/fsc/kondate-list">献立リスト</a></p>
              <p><a routerLink="/fsc/kondate-class-list">献立分類リスト</a></p>
              <p><a routerLink="/fsc/kondate-otomo-list">オトモ献立リスト</a></p>
              <!-- <p><a routerLink="/fsc/print-invoice">請求書印刷</a></p> -->
              <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                  routerLink="/fsc/fsc-selfregi-rsv-result">セルフレジ実績リスト</a></p>
            </div>
          </div>

          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.INDIVIDUAL" class="footer-block">
            <p class="footer-title">メニュー</p>
            <div class="footer-menu">
              <p *ngIf="!authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                  routerLink="/individual/reservation-list">予約リスト</a></p>
              <p *ngIf="!authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                  routerLink="/individual/input-reservation">予約入力</a></p>
              <p *ngIf="authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                  routerLink="/individual/indi-rsv-calendar">予約カレンダー</a></p>
              <p *ngIf="authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                  routerLink="/individual/auto-rsv-settings">自動予約設定</a></p>
              <p *ngIf="authServ.guestReservationAuth === GUEST_RESERVATION_AUTH.AUTHORIZED &&
                !authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                  routerLink="/individual/g-reservation-list">ゲスト予約リスト</a></p>
              <p *ngIf="authServ.guestReservationAuth === GUEST_RESERVATION_AUTH.AUTHORIZED &&
                !authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                  routerLink="/individual/g-input-reservation">ゲスト予約入力</a></p>
              <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                  routerLink="/individual/selfregi-usage-history">セルフレジ利用履歴</a></p>
              <p
                *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE">
                <a routerLink="/individual/nutrition-balance">栄養バランス</a>
              </p>
            </div>
          </div>
        </section>
        <section class="col-auto footer-block">
          <p class="footer-title">クラウド型給食予約サービスSmile9</p>
          <div class="footer-menu">
            <p><a [href]="SKS_WEBSITE" target="_blank" rel="noreferrer">運営会社サイト</a></p>
            <p><a [href]="SKS_WEBSITE + 'privacy-policy2'" target="_blank" rel="noreferrer">プライバシーポリシー</a></p>
            <p><a [href]="SKS_TERMS_OF_SERVICE" target="_blank" rel="noreferrer">サービス利用規約</a></p>
            <p><a [href]="SKS_WEBSITE + 'archives/528'" target="_blank" rel="noreferrer">推奨環境</a></p>
          </div>
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS || authServ.smile9Role === SMILE9_ROLES.FSC">
            <p class="footer-title" style="margin-top: 32px;"><a [href]="MAIN_USER_GUIDE" target="_blank"
                rel="noreferrer" style="text-decoration: underline;">ご利用ガイド<img
                  [src]="utilServ.uUI.icongram('fontawesome','external-link', 14, 'ffffff')" alt="" aria-hidden="true"
                  style="padding-right: 4px;"></a>で解決できない場合は、Smile9サポートチームまでお問い合わせください</p>
            <div class="footer-menu">
              <p>メール：support@smile9-sks.com</p>
              <p>電話：050-1741-6665</p>
              <p>受付時間：平日 9:00〜17:00</p>
              <p>＊11:50〜13:00を除く</p>
              <p>＊土日祝・弊社休業日を除く</p>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="nav-footer2 text-center" [class.d-none]="authServ.smile9Role === SMILE9_ROLES.ITADAKIMASU ||
                                                          authServ.smile9Role === SMILE9_ROLES.MENU_DISPLAY">
      Copyright &copy; 2019- All rights reserved. S.K.S. Inc.
    </div>
  </section>

  <!-- スマホのみ -->
  <section id="only-phone">
    <div class="nav-footer" [class.d-none]="authServ.smile9Role === SMILE9_ROLES.KITCHEN ||
                                            authServ.smile9Role === SMILE9_ROLES.ITADAKIMASU ||
                                            isRegisterFavInUrl">
      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS">
        <p class="footer-title">予約</p>
        <div class="ml-4">
          <div>
            <p *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_DASHBOARD">
              <a routerLink="/general-affairs/reservation/ga-dashboard">ダッシュボード</a>
            </p>
            <p><a routerLink="/general-affairs/reservation/ga-rsv-result">予約実績リスト</a></p>
            <p><a routerLink="/general-affairs/reservation/ga-rsv-status">予約状況リスト</a></p>
            <p><a routerLink="/general-affairs/reservation/ga-individual-rsv-status">個人予約状況リスト</a></p>
            <p><a routerLink="/general-affairs/reservation/display-rsv-log">予約ログ照会</a></p>
            <p><a routerLink="/general-affairs/reservation/rsv-log">いただきますログ照会</a></p>
            <p><a routerLink="/general-affairs/reservation/ga-input-rsv">予約入力</a></p>
            <p><a routerLink="/general-affairs/reservation/bulk-rsv">予約一括入力</a></p>
            <p><a routerLink="/general-affairs/reservation/ga-edit-rsv">予約編集</a></p>
            <p><a routerLink="/general-affairs/reservation/update-in-bulk">予約一括編集</a></p>
            <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                routerLink="/general-affairs/reservation/modify-regi-result">セルフレジ実績編集</a></p>
            <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                routerLink="/general-affairs/reservation/ga-selfregi-rsv-result">セルフレジ実績リスト</a></p>
            <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                routerLink="/general-affairs/reservation/ga-individual-regi-rsv-status">個人セルフレジ実績リスト</a></p>
          </div>
        </div>
      </div>
      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS">
        <p class="footer-title">総務</p>
        <div class="ml-4">
          <div>
            <p><a routerLink="/general-affairs/general-affairs/automenu">自動メニュー登録</a></p>
            <p
              *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_RSV">
              <a routerLink="/general-affairs/general-affairs/ga-modify-rsv">予約調整入力</a>
            </p>
            <p
              *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_ATE">
              <a routerLink="/general-affairs/general-affairs/modify-result">実績調整入力</a>
            </p>
            <p
              *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_FAXMAIL_SETTINGS">
              <a routerLink="/general-affairs/general-affairs/faxmail-settings">FAX送信設定</a>
            </p>
            <p><a routerLink="/general-affairs/general-affairs/dl-data">データDL</a></p>
            <p><a routerLink="/general-affairs/general-affairs/dl-data-custom">データDLカスタマイザ</a></p>
            <p><a routerLink="/general-affairs/general-affairs/guest-info">ゲスト情報リスト</a></p>
            <p><a routerLink="/general-affairs/general-affairs/register-felica">Smile9ID登録</a></p>
            <p><a routerLink="/general-affairs/general-affairs/edit-notice">通知編集</a></p>
            <p
              *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE">
              <a routerLink="/general-affairs/general-affairs/ga-nutrition-balance">栄養バランス</a>
            </p>
          </div>
        </div>
      </div>
      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS">
        <p class="footer-title">管理</p>
        <div class="ml-4">
          <div>
            <p class="footer-subtitle">基本情報</p>
            <p><a routerLink="/general-affairs/master/company">会社リスト</a></p>
            <p><a routerLink="/general-affairs/master/department">部署リスト</a></p>
            <p><a routerLink="/general-affairs/master/employee">社員リスト</a></p>
            <p><a routerLink="/general-affairs/master/import-emp-csv">社員CSV取込</a></p>
            <p><a routerLink="/general-affairs/master/holiday-pattern">休日パターン設定</a></p>
          </div>
          <div>
            <p class="footer-subtitle">Smile9情報</p>
            <div class="row">
              <div class="col-12">
                <p><a routerLink="/general-affairs/master/cafeteria">食堂リスト</a></p>
                <p><a routerLink="/general-affairs/master/cafe-opening-hours">食堂設定</a></p>
                <p><a routerLink="/general-affairs/master/bill">請求先リスト</a></p>
                <p><a routerLink="/general-affairs/master/cafe-bill">食堂請求先設定</a></p>
                <p
                  *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.DISPLAY_GA_ITADAKIMASU_SETTINGS">
                  <a routerLink="/general-affairs/master/itadakimasu-settings">いただきます端末設定</a>
                </p>
                <p><a routerLink="/general-affairs/master/cafe-business-calendar">食堂営業日カレンダー</a></p>
                <p><a routerLink="/general-affairs/master/sei-kbn">請求区分リスト</a></p>
                <p><a routerLink="/general-affairs/master/menu-type">メニュー種類リスト</a></p>
                <p><a routerLink="/general-affairs/master/menu-tanka">メニュー単価設定</a></p>
                <p><a routerLink="/general-affairs/master/cafe-hojo-group">補助食堂グループリスト</a></p>
                <p><a routerLink="/general-affairs/master/cafe-hojo-settings">補助食堂設定</a></p>
                <p><a routerLink="/general-affairs/master/menu-pattern">メニューパターン設定</a></p>
                <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'"><a
                    routerLink="/general-affairs/master/sub-menu-group">サブメニューグループリスト</a></p>
                <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'"><a
                    routerLink="/general-affairs/master/sub-menu-pattern">サブメニューパターン設定</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC">
        <p class="footer-title">メニュー</p>
        <div class="ml-4">
          <div>
            <p *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_DASHBOARD">
              <a routerLink="/fsc/fsc-dashboard">ダッシュボード</a>
            </p>
            <p><a routerLink="/fsc/fsc-rsv-result">予約実績リスト</a></p>
            <p><a routerLink="/fsc/import-menu-csv">食堂メニューCSV取込</a></p>
            <p><a routerLink="/fsc/menu-list">食堂メニューリスト</a></p>
            <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'"><a
                routerLink="/fsc/sub-menu-list">サブメニューリスト</a></p>
            <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'"><a
                routerLink="/fsc/sub-menu-settings">サブメニュー設定</a></p>
            <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                routerLink="/fsc/self-regi-menu-list">セルフレジメニューリスト</a></p>
            <p><a routerLink="/fsc/kondate-list">献立リスト</a></p>
            <p><a routerLink="/fsc/kondate-class-list">献立分類リスト</a></p>
            <p><a routerLink="/fsc/kondate-otomo-list">オトモ献立リスト</a></p>
            <!-- <p><a routerLink="/fsc/print-invoice">請求書印刷</a></p> -->
            <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                routerLink="/fsc/fsc-selfregi-rsv-result">セルフレジ実績リスト</a></p>
          </div>
        </div>
      </div>

      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.INDIVIDUAL">
        <p class="footer-title">メニュー</p>
        <div class="ml-4">
          <div>
            <p *ngIf="!authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                routerLink="/individual/reservation-list">予約リスト</a></p>
            <p *ngIf="!authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                routerLink="/individual/input-reservation">予約入力</a></p>
            <p *ngIf="authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                routerLink="/individual/indi-rsv-calendar">予約カレンダー</a></p>
            <p *ngIf="authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                routerLink="/individual/auto-rsv-settings">自動予約設定</a></p>
            <p *ngIf="authServ.guestReservationAuth === GUEST_RESERVATION_AUTH.AUTHORIZED &&
              !authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                routerLink="/individual/g-reservation-list">ゲスト予約リスト</a></p>
            <p *ngIf="authServ.guestReservationAuth === GUEST_RESERVATION_AUTH.AUTHORIZED &&
              !authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')"><a
                routerLink="/individual/g-input-reservation">ゲスト予約入力</a></p>
            <p *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'"><a
                routerLink="/individual/selfregi-usage-history">セルフレジ利用履歴</a></p>
            <p
              *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE">
              <a routerLink="/individual/nutrition-balance">栄養バランス</a>
            </p>
          </div>
        </div>
      </div>

      <div>
        <p class="footer-title">クラウド型給食予約サービス Smile9</p>
        <div class="ml-4">
          <div>
            <p><a [href]="SKS_WEBSITE" target="_blank" rel="noreferrer">運営会社サイト</a></p>
            <p><a [href]="SKS_WEBSITE + 'privacy-policy2'" target="_blank" rel="noreferrer">プライバシーポリシー</a></p>
            <p><a [href]="SKS_TERMS_OF_SERVICE" target="_blank" rel="noreferrer">サービス利用規約</a></p>
            <p><a [href]="SKS_WEBSITE + 'archives/528'" target="_blank" rel="noreferrer">推奨環境</a></p>
          </div>
        </div>
        <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS || authServ.smile9Role === SMILE9_ROLES.FSC">
          <p class="footer-title"><a [href]="MAIN_USER_GUIDE" target="_blank" rel="noreferrer">ご利用ガイド<img
                [src]="utilServ.uUI.icongram('fontawesome','external-link', 12, 'ffffff')" alt="" aria-hidden="true"
                style="padding-right: 4px;"></a>で解決できない場合は、Smile9サポートチームまでお問い合わせください
          </p>
          <div class="ml-4">
            <div>
              <p>メール：support@smile9-sks.com</p>
              <p>電話：050-1741-6665</p>
              <p>受付時間：平日 9:00〜17:00</p>
              <p>＊11:50〜13:00を除く</p>
              <p>＊土日祝・弊社休業日を除く</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-footer2 text-center">
      Copyright &copy; 2019- All rights reserved. S.K.S. Inc.
    </div>
  </section>
</footer>

<!-- ↓TOPへスクロールボタン -->
<span *ngIf="utilServ.uUI.scrollTopBtnVisible && !authServ.isPrinting" class="scroll-top-btn" (click)="scrollTop()">
  <img src="../assets/images/scroll_top_button.png" class="img-fluid center-block">
</span>

<!-- チュートリアル用Component -->
<app-tutorial></app-tutorial>

<!-- 自動処理用Componentを常に表示 -->
<app-auto-act></app-auto-act>

<div *ngIf="environmentName !== 'prod'" id="current-env-label" [class]="environmentName">
  <div *ngIf="environmentName === 'dev'" class="env-name">開発環境</div>
  <div *ngIf="environmentName === 'test'" class="env-name">検証環境</div>
  <div class="remove-btn" (click)="removeEnvLabel()">×</div>
</div>